/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ENTITYNAME, PUBLISHING_SOURCE, MEDIACATEGORIES, OTTROUTETYPE, ASSETTYPE, MODULE, LOGEVENT, LOCALSTORAGE_KEY, ACCESS_LEVEL, BA_ACTION, MEDIA_TRANSMISSION, CONTENT_CUSTOM_ENUM, TOAST_TYPES } from "../../framework/constant/constant";
import * as API from "../../framework/API/api"
import { CardList } from "../../components/CardList";
import AddNewEpisodesForm from "./AddNewEpisodesForm";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import SeasonMetaDataEditForm from "./SeasonMetaDataEditForm";
import SeasonDetailForm from "./SeasonDetailForm";
import { FixedSidebarWithIcons } from "../../components/FixedSidebarWithIcons"
import MediaEpisodePublishingEditForm from './MediaEpisodePublishingEditForm';
import { EditPageHeader } from '../../components/EditPageHeader';
import { useTranslation } from '../../locale/useTranslation';
import MediaEpisodeAssetEditForm from './MediaEpisodeAssetEditForm';
import moment from 'moment';
import { ConfirmAlert } from '../../ConfirmAlert';
import { DataHelper } from '../../framework/helper/DataHelper';
import { utility } from '../../framework/utility/utilityProvider';
import BossAssistantIcon from './component/BossAssistantIcon';
import { TransmissionBrowser } from './NodeTreeView/TransmissionBrowser';
import ToastNotification from '../../components/ToastNotification';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import SyncSeasonWithEpisodeForm from './SyncSeasonWithEpisodeForm';

function SeasonEditForm(props) {

  const location = useLocation();
  const { SID } = useParams();
  const navigate = useNavigate();
  const lang = useTranslation();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  const [showAddEpisode, setShowAddEpisode] = useState(false);
  const [episodes, setEpisodes] = useState([]);
  const [archiveEpisode, setArchiveEpisode] = useState(false);

  const isAssestID = utility.isNumeric(SID) == false;
  const isEdit = isAssestID || SID > 0 ? true : false;
  const [disableSave, setDisableSave] = useState(isEdit);
  const [isArchiveChanged, setIsArchiveChanged] = useState(false);
  const [openEpisodes, setOpenEpisodes] = useState(isEdit);

  const [isSaving, setIsSaving] = useState(false);
  const [createEpisodeDataItem, setCreateEpisodeDataItem] = useState(
    location.state && location.state.isFromAddProgram && location.state.createEpisodeDataItem ?
      location.state.createEpisodeDataItem :
      {
        NumberOfEpisodes: 1,
        Content: {},
        StartingEpisodes: 1,
        Duration: "00:00:00:00",
      }
  );

  const blankDataItem = {
    SID: SID,
    Title: '',
    Content: {},
    Description: '',
    Synopsis: "",
    ImageUrl: 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png',
    Synopsis: '',
    SeasonSynopsis: [],
    Genres: [],
    SubGenres: [],
    MediaType: {},
    MediaSubType: {},
    ProductionYear: '',
    IsLive: false,
    Languages: [],
    Keywords: '',
    SeasonNumber: 1,
    PGRating: {},
    SeasonCode: '',
    Transmission: { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) },
    // TargetGroup: {},
    Categories: [],
    Provider: {},
    Extension: {},
    dynamicField: {},
    DubbedLanguages: [],
    Country: {},
    Channels: [],
    Platforms: [],
    isLinearUnlimitedRights: true,
    LinearStartDate: null,
    LinearEndDate: null,
    isNonLinearUnlimitedRights: true,
    NonLinearStartDate: null,
    NonLinearEndDate: null,
    Settings: {
      Colors: { Foreground: null, Background: null }, RouterCommand: "", HardDisk: ""
    }
  }

  const [seasonEntity, setSeasonEntity] = useState(
    location.state && location.state.isFromAddProgram && location.state.dataItem ?
      { ...blankDataItem, ...location.state.dataItem } : blankDataItem);
  const [tempSeasonEntity, setTempSeasonEntity] = useState(
    location.state && location.state.isFromAddProgram && location.state.dataItem ?
      { ...blankDataItem, ...location.state.dataItem } : blankDataItem);

  const [tabNumber, setTabNumber] = React.useState("1");
  const [mediaEpisodeEntity, setMediaEpisodeEntity] = useState({});
  const [mediaCategory, setMediaCategory] = useState([]);
  const [genres, setGenres] = useState([]);
  const [pGRatings, setPGRatings] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [assetDataItem, setAssetDataItem] = useState({});

  const [isLoadedEdit, setIsLoadedEdit] = useState(false);
  const [imagePotraitImageFiles, setPotraitImageFiles] = useState(new Set());
  const [imageLandscapeImageFiles, setLandscapeImageFiles] = useState(new Set());
  const [selectedSeries, setSelectedSeries] = useState({ Title: '' });

  const [openPublishingDialog, setOpenPublishingDialog] = useState(false);
  const [isManualAssetId, setIsManualAssetId] = useState(false);
  const [isEpisodeLoading, setIsEpisodeLoading] = useState(true);
  const [showSyncSeasonWithEpisodeForm, setShowSyncSeasonWithEpisodeForm] = useState(false);

  const customeModelFields = {
    Title: "Title",
    Description: "Description",
    PosterURL: "ImageUrl",
    ThirdLine: "EpisodeNumber"
  }

  useEffect(() => {
    loadCombo();
    if (isEdit) {
      loadSeason();
    } else {
      setIsLoadedEdit(true);
    }
  }, [SID]);

  const loadCombo = async () => {
    let mediaCategory = await API.getDataLookup(ENTITYNAME.MediaCategory);
    setMediaCategory(mediaCategory.data);

    let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
    setGenres(genreRes.data);

    let pgRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPGRatings(pgRes.data);

    let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(languagesRes.data);

  }

  const loadSeason = async () => {

    let res = { message: "Not Valid", success: false };

    if (isAssestID) {
      res = await API.getEntityfromAssestID(ENTITYNAME.Season, SID);
    }
    else {
      res = await API.getEntity(ENTITYNAME.Season, parseInt(SID));
    }

    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }

    let seasonData = {
      ...blankDataItem,
      ...res.data,
      Transmission: res?.data?.Transmission ? { _id: res?.data?.Transmission, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, res?.data?.Transmission) } : { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) },
      Provider: typeof res?.data?.Provider === 'string' ? { Description: res?.data?.Provider } : res?.data?.Provider?._id ? res?.data?.Provider : {},
      Content: {
        ...res?.data?.Content,
        Custom: res?.data?.Country && Object.keys(res?.data?.Country || {}).length > 0 ? CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP : null
      },
      Country: res?.data?.Country ?? {}
    }

    setSeasonEntity(seasonData);
    setTempSeasonEntity(seasonData);

    setIsLoadedEdit(true);
    setMediaEpisodeEntity(res.data);
    loadParentSeries(res.data);

    //load asset details
    if (res.data?.IsOttAsset) {
      let assetRes = await API.getData(ENTITYNAME.OttAsset, { query: [['Source._id', '=', res.data._id], ['Source.entityName', '=', 'season']] });
      console.log(assetRes);
      if (assetRes.data && assetRes.data.length > 0) {
        [
          setAssetDataItem({ ...assetRes.data[0], IsOttAsset: res.data.IsOttAsset })
        ]
      }
    }

    //to get linked episodes of seasons
    await loadEpisodes(res.data?._id, res.data?.Archive);

  };

  const loadParentSeries = async (dataItem) => {

    if (dataItem?.Series_Id) {

      let resSeries = await API.getData(ENTITYNAME.Series, { query: ['_id', '=', dataItem.Series_Id] });
      if (!resSeries.success || resSeries.data.length == 0) return;

      setSelectedSeries(() => resSeries.data[0] ?? { Title: "" });
    }

  }

  const createNewSeasonEpisode = async (seasonId, data) => {

    let episodes = [];
    if (data.SID == 0) {
      const createEpisodesData = {
        seasonId: seasonId,
        contentsid: createEpisodeDataItem.Content.SID,
        episodes: parseInt(createEpisodeDataItem.NumberOfEpisodes),
        duration: utility.convertStringWithFramesToMilliseconds(createEpisodeDataItem.Duration),
        startingepisode: parseInt(createEpisodeDataItem.StartingEpisodes),
        Genres: seasonEntity.Genres,
        SubGenres: seasonEntity.SubGenres ?? [],
        MediaType: seasonEntity.MediaType,
        MediaSubType: seasonEntity.MediaSubType,
        ReferenceCode: seasonEntity.SeasonCode,
        Synopsis: seasonEntity.Synopsis,
        CustomTitle: seasonEntity.CustomTitle,
        ShortTitle: seasonEntity.ShortTitle,
        CustomShortTitle: seasonEntity.CustomShortTitle,
        CustomDescription: seasonEntity.CustomDescription,
        Settings: data?.Settings ?? getSeasonSettingsColor(),
        episodesList: createEpisodeDataItem.EpisodesList ?? []
      }

      let response = await API.createSeriesMediaEpisodes(createEpisodesData);
      episodes = response.data
      if (!response.success) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
        return null;
      } else {

        if (episodes?.length > 0) {
          episodes?.map((episode) => {
            let logData = { event: LOGEVENT.CREATE_EPISODE, module: MODULE.EPISODE, data: episode.data, message: "Create Episode" };
            API.SaveLogs(logData);
          });
        }

      }
      return response;
    }
    return null;

  }

  const saveArchiveChange = async () => {
    if (isArchiveChanged && seasonEntity.SID > 0) {
      console.log('------here------')
      let mediaEpisodeData = await API.getData(ENTITYNAME.MediaEpisode, { query: [["Season_id", "=", seasonEntity._id.toString()]] });
      await API.onChangeArchiveInSeriesSeason({
        _id: seasonEntity._id,
        archive: seasonEntity.Archive,
        entityName: ENTITYNAME.Season
      });
      if (!mediaEpisodeData.success) return;
      await onArchiveEpisodes(mediaEpisodeData, seasonEntity.Archive);
      setIsArchiveChanged(false);
    }
  }

  const getSeasonSettingsColor = (settings) => {
    let backgroundColor = utility.getRandomLightColor();
    let foregroundColor = utility.getRandomDarkColor();
    return {
      Colors: {
        Foreground: settings?.Colors?.Foreground ?? foregroundColor, Background: settings?.Colors?.Background ?? backgroundColor
      },
      RouterCommand: settings?.RouterCommand ?? "",
      HardDisk: settings?.HardDisk ?? ""
    }
  }

  const onSave = async () => {
    if (seasonEntity?.Extension?.subtitleLanguages && /[^\p{L}\p{N}\s;]|;;/u.test(seasonEntity.Extension.subtitleLanguages)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.subtitle_languages_error_message });
      return;
    }

    setIsSaving(true);
    try {

    let localSeasonEntity = { ...seasonEntity };

    const season_id = localSeasonEntity._id;

    let data = DataHelper.saveSeasonEntity(seasonEntity, mediaCategory, assetDataItem?.IsOttAsset, seasonEntity?.Series_Id, seasonEntity?.ImageUrl, localSeasonEntity.CastAndCrew);

    if (data?._id && data?._id?.toString()?.length > 0) {
      delete data._id
    }

    if (assetDataItem.IsOttAsset && !isValidAsset()) {
      return;
    }

    if (data?.SID == 0 && !isManualAssetId) {
      data.AssetId = await DataHelper.getNewAssetId(localSeasonEntity.Content, true);
      data.Settings = getSeasonSettingsColor(data.Settings);
    }

    let res = await API.saveData(ENTITYNAME.Season, data);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }

    //CREATE NEW SEASON AND EPISODES
    let newEpisodeRes = await createNewSeasonEpisode(res.data._id, data);
    if (newEpisodeRes) handleSetSeasonEntity(res.data, newEpisodeRes?.data);

    // Update season episode count
    await API.updateSeasonEpisodeCount({
      data: res.data, //season saved entity
      entityName: ENTITYNAME.Season
    });

    //SYNC SeasonEpisodeWorkingTitle
    API.saveSeasonEpisodeWorkingTitle(res.data._id)

    //ARCHIVE DATA FOR WHOLE SEASON 
    await saveArchiveChange();

    //PUBLISHING TAB SAVE OR CREATING DEAFAULT rights
    let resMediaDealRights = {};

    // New saving of deal rights
    if (SID == 0) {
      let transmissionTypes = await API.getDataLookup(ENTITYNAME.TransmissionTypes);
      let defaultDealRightsData = DataHelper.getDefaultDealRights({ transmissionType: transmissionTypes?.data?.find(x => x?.Name?.toLowerCase() === "svod"), isLinearUnlimitedRights: seasonEntity?.isLinearUnlimitedRights, linearStartDate: seasonEntity?.LinearStartDate, linearEndDate: seasonEntity?.LinearEndDate, isNonLinearUnlimitedRights: seasonEntity?.isNonLinearUnlimitedRights, nonLinearStartDate: seasonEntity?.NonLinearStartDate, nonLinearEndDate: seasonEntity?.NonLinearEndDate, channels: seasonEntity?.Channels, platforms: seasonEntity?.Platforms, publishingSource: PUBLISHING_SOURCE.Season })
      resMediaDealRights = await API.createAndUpdateDealRights(defaultDealRightsData, res.data._id);
    }

    //OTT ASSET TAB SAVE
    let assetsData = {};
    if (assetDataItem.IsOttAsset) {
      let assetRes = await onAssetSubmit({ ...res.data, _id: season_id });
      if (assetRes.success) {
        assetsData = assetRes.data
      }
    }

    let logData = {
      event: localSeasonEntity.SID == 0 ? LOGEVENT.CREATE_SERIES : LOGEVENT.UPDATE_SERIES,
      module: MODULE.MEDIA_EPISODE_SEASON,
      data: { ...res.data, MediaDealRights: resMediaDealRights.data, _id: season_id, Assets: assetsData },
      message: res.message
    };
    API.SaveLogs(logData);
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Saved Successfully" });

    if (props.quickEdit) {
      navigate(location.state.prevPath);
    } else {
      let findIndex = location?.state?.prevPath.indexOf("?");
      let pagination = location?.state?.prevPath?.slice(findIndex, location?.state?.prevPath?.length) ?? "";
      let state = {
        quickEdit: false,
        prevPath: location?.state?.prevPath ?? "/home/MediaEpisode/Season",
        pagination: location?.state.pagination ?? pagination,
        paths: location.state.paths
      }
      navigate(`/home/MediaEpisode/Season/${res.data.SID}`, { state: state });
    }

    setOpenEpisodes(true);

    } catch (error) {
      console.error(error);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    } finally {
      setIsSaving(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const setMataData = (data) => {
    //setCastAndCrew({...castAndCrew,...data.CastAndCrew});
    setSeasonEntity({ ...seasonEntity, ...data });
  }

  const getMenu = (index, dataItem) => {
    return [
      {
        label: `${lang.options_actionbutton_menutext}`,
        items: [
          { label: `${lang.delete_actionbutton_option}`, icon: 'pi pi-fw pi-trash', command: () => { } },
          { label: `${lang.moveup_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-up ', command: () => { } },
          { label: `${lang.movedown_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-down', command: () => { } }
        ]
      }
    ]
  }

  const onShowHideAddEpisode = () => {
    setShowAddEpisode((old) => !old);
  }

  const handleSetingEpisode = (data) => {
    let temp = [];

    data.map((obj) => {
      temp = [...temp, obj.data];
    })

    console.log(temp);
    setEpisodes((old) => [...old, ...temp]);
  }

  const handleSetSeasonEntity = (data, episodeData) => {

    console.log(data);

    setSeasonEntity(data);

    let tempData = [];
    if (episodeData.length > 0) {
      episodeData.map((obj) => {
        tempData.push(obj.data);
      })
      setEpisodes(tempData);
    }

    loadEpisodes(data._id, false);

  }

  const handleSetDisableSave = (value) => {
    setDisableSave(value);
  }

  const sideFixMenu = [
    {
      icon: 'play',
      title: `${lang.sidefix_episode_tooltip}`,
      onClick: () => { setOpenEpisodes(old => !old) }
    },
  ]

  const deleteEpisode = async (index, dataItem) => {
    console.log(dataItem);

    setEpisodes((old) => old.filter((obj) => obj.SID != dataItem.SID));
    let res = await API.deleteData(ENTITYNAME.MediaEpisode, dataItem.SID);
    if (!res.success) return;

  }

  const onEpisodeEdit = (index, dataItem) => {
    console.log(dataItem);
    let findIndex = location?.state?.prevPath.indexOf("?");
    let paths = location?.state && location?.state?.paths ? [...location?.state?.paths, location?.pathname] : [location?.pathname];
    let state = {
      quickEdit: false,
      prevPath: location?.pathname,
      pagination: location?.state?.pagination ? location?.state?.pagination : location?.state?.prevPath?.slice(findIndex, location?.state?.prevPath?.length) ?? "",
      paths: paths
    }
    navigate(`/home/MediaEpisode/Episode/${dataItem?.SID}`, { state: state });
  }

  //asset
  const setAssetEntity = (entity) => {
    setAssetDataItem(entity)
  }

  function isValidAsset() {

    let routeTypeID = typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType;

    if (!assetDataItem.VodTypes || Object.keys(assetDataItem.VodTypes).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_vod_type_validation_error_message });
      return false;
    }

    if (!routeTypeID || routeTypeID === "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_route_type_error_message });
      return false;
    }

    if ((assetDataItem.routeType == (OTTROUTETYPE.Page || OTTROUTETYPE.PiPage) || assetDataItem.routeType.ID == (OTTROUTETYPE.Page || OTTROUTETYPE.PiPage)) && (assetDataItem.page_id == "" || assetDataItem.page_id == undefined)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page });
      return false;
    }

    if ((assetDataItem.routeType == OTTROUTETYPE.Player || assetDataItem.routeType.ID == OTTROUTETYPE.Player)
      && assetDataItem.Videos.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_video_error_message });
      return false;
    }

    let videosArr = utility.getItemDisplayValueByLang(assetDataItem.Videos, company.Language)
    if (routeTypeID == OTTROUTETYPE.Deeplink && !videosArr.some(x => x.OttVideoType?.Description === "Deeplink")) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_add_deeplink_in_video_list_error_message });
      return false;
    }

    if (assetDataItem.Videos.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_video_error_message });
      return false;
    }

    if (assetDataItem.Posters.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_poster_error_message });
      return false;
    }

    return true;
  }

  const onAssetSubmit = async (seasonEntity) => {

    //MUTILANG TITLE & DESCRIPTION
    let title = assetDataItem.Title && assetDataItem.Title.length > 0 ? assetDataItem.Title : [
      {
        langISO: company.Language.ISOCode,
        value: mediaEpisodeEntity.Title
      }
    ];
    let description = assetDataItem.Description && assetDataItem.Description.length > 0 ? assetDataItem.Description : [
      {
        langISO: company.Language.ISOCode,
        value: assetDataItem.Description
      }
    ];

    const saveData = {
      Title: title,
      Description: description,
      TBA: assetDataItem.TBA ?? false,
      StartDate: assetDataItem.StartDate ? new Date(assetDataItem.StartDate).getTime() : new Date(moment(new Date()).format('YYYY-MM-DD')).getTime(),
      EndDate: assetDataItem.EndDate ? new Date(assetDataItem.EndDate).getTime() : new Date(moment(new Date()).add(1, 'M').format('YYYY-MM-DD')).getTime(),
      OttAssetTypeSID: ASSETTYPE['Media Asset'],
      Provider: assetDataItem?.Provider?._id ? assetDataItem?.Provider?._id : "",
      Archive: assetDataItem.Archive ?? false,
      Source: { _id: seasonEntity._id, SID: seasonEntity.SID, Title: seasonEntity.Title, MediaCategory: seasonEntity.MediaCategory, entityName: 'season' },
      routeType: typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType,
      page_id: typeof assetDataItem.page_id === 'object' ? assetDataItem.page_id._id : assetDataItem.page_id,
      VodTypes: {
        _id: assetDataItem.VodTypes._id,
        SID: assetDataItem.VodTypes.SID,
        Name: assetDataItem.VodTypes.Name
      },
      Videos: assetDataItem.Videos ?? [],
      Posters: assetDataItem.Posters ?? [],
      RentalRetailPrice: assetDataItem.VodTypes.Name == 'TVOD' ? assetDataItem.RentalRetailPrice : 0,
      RentalWholesalePrice: assetDataItem.VodTypes.Name == 'TVOD' ? assetDataItem.RentalWholesalePrice : 0,
      WebAssets: assetDataItem?.WebAssets ? assetDataItem?.WebAssets?._id : "",
      accessLevel: assetDataItem?.accessLevel?._id ?? ACCESS_LEVEL.Both,
      SubTitles: assetDataItem?.SubTitles && assetDataItem?.SubTitles.length > 0 ? assetDataItem?.SubTitles : [],
      thumbnailUrl: assetDataItem?.thumbnailUrl ?? "",
      Segments: (assetDataItem?.Segments && assetDataItem?.Segments?.length > 0) ? assetDataItem?.Segments?.map((x) => {
        return {
          _id: x?._id,
          Description: x?.Description
        }
      }) : []
    }

    if (assetDataItem._id != undefined) {
      saveData._id = assetDataItem._id;
      saveData.SID = assetDataItem.SID
    }

    console.log(saveData);

    let res = await API.saveData(ENTITYNAME.OttAsset, saveData);

    let logData = { event: res.message == "inserted" ? LOGEVENT.CREATE_ASSETS : LOGEVENT.UPDATE_ASSETS, module: MODULE.OTT_ASSETS, data: res.data, message: res.message };
    API.SaveLogs(logData);

    return res;

  };

  const onArchiveEpisodes = async (data, archive) => {

    //for array
    if (data.length > 0) {

      let response = [];

      for (const element of data) {
        const item = element;
        let res = await API.saveData(ENTITYNAME.MediaEpisode, { _id: item._id, Archive: !archive });
        if (!res.success) {
          console.log(res)
        }
        // Log Capture
        let logData = { event: LOGEVENT.UPDATE_EPISODE, module: MODULE.EPISODE, data: { ...item, Archive: !archive }, message: res.message };
        API.SaveLogs(logData);
        response.push(res);
      }
      setArchiveEpisode(archive);
      loadEpisodes(seasonEntity._id, archive);
    }
  }

  const loadEpisodes = async (seasonID = seasonEntity._id, archive = false) => {
    let responseMediaEpisode = await API.getData(ENTITYNAME.MediaEpisode, { query: [['Season_id', '=', seasonID], ['Archive', '=', archive]], sort: { EpisodeNumber: 1 } });
    if (!responseMediaEpisode.success) return;

    setEpisodes(responseMediaEpisode.data);
    setIsEpisodeLoading(false);
    setArchiveEpisode(archive);
    return responseMediaEpisode.data;

  }

  const onCancel = () => {

    console.log(seasonEntity);
    console.log(location.state);

    if (seasonEntity.SID == 0) {

      ConfirmAlert(() => {
        if (location.state && location.state.prevPath) {
          navigate(location.state.prevPath)
        } else {
          navigate(-1) ? navigate(-1) : window.close();
        }
      }, () => { return; }, "Discard changes?", "Are you sure you want to discard changes?")
    } else {
      if (location.state && location.state.prevPath) {
        let state = {
          ...location.state,
          pagination: location.state.pagination ?? "",
          // prevPath: location?.state?.prevPath,
          paths: location.state.paths.slice(0, -1)
        }
        navigate(location.state.paths.length == 1 ? location.state.paths.pop() + location.state.pagination ?? "" : location.state.paths.pop(), { state: state })
      } else {
        navigate(-1) ? navigate(-1) : window.close();
      }
    }


  }

  //ON BOSS ASSISTANT ICON CLICK
  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.FullMetaData, item, mediaEpisodeEntity);
    console.log(aiDataRes);
    return aiDataRes;

  }

  //FUNCTION FOR FETCHING META DATAFROM BOSS AI
  const setMetaData = (data) => {

    console.log("HERE IN SEASON BOSS AI")
    console.log(data);

    let newMetaData = {
      Title: data.Title,
      Description: data.Description,
      Synopsis: data.Synopsis && data.Synopsis.length > 0 ? data.Synopsis[0].Synopsis : "",
      Genres: genres.filter((x) => x.Description.toLowerCase() == data.Genre.toLowerCase()),
      SubGenres: genres.filter((x) => x.Description.toLowerCase() == data.SubGenre.toLowerCase()),
      ProductionYear: data.ProductionYear ?? '',
      Languages: data.Languages && data.Languages.length > 0 ?
        data.Languages.map((item) => { return languages.find((x) => x.Description && x.Description.toLowerCase() == item.toLowerCase()) }) : [],
      Keywords: data.Keywords ?? '',
      PGRating: pGRatings.find((x) => x.Description == data.PGRating) ? pGRatings.find((x) => x.Description == data.PGRating) : {},
      Categories: data?.Categories && data?.Categories?.length > 0 ? data?.Categories?.map((item) => {
        return {
          _id: item?._id,
          Name: item?.Name,
          parent: item?.parent
        }
      }) : [],
      Extension: data?.Extension ?? {},
      dynamicField: data?.dynamicField ?? {},
      DubbedLanguages: data.DubbedLanguages && data.DubbedLanguages.length > 0 ?
        data.DubbedLanguages.map((item) => { return languages.find((x) => x.Description && x.Description.toLowerCase() == item.toLowerCase()) }) : []
    }


    setSeasonEntity({ ...seasonEntity, ...newMetaData });

    setMediaEpisodeEntity({ ...seasonEntity, ...newMetaData });

  }

  return (<>
    <div className="myFlexContainer">
      <FixedSidebarWithIcons menuModel={sideFixMenu} />
      {openEpisodes && <CardList
        isWide={true}
        showMultiSelect={true}
        MenuModal={getMenu}
        containerName="Destination"
        close={() => setOpenEpisodes(false)}
        customeModelFields={customeModelFields}
        title={lang.season_cardlist_header}
        onAddClick={onShowHideAddEpisode}
        posterURL="https://play-lh.googleusercontent.com/LsmwRk16eEuZXxYLc-FGARu72Ji1qQq3Ow5d0aQ6tX2JE_yAFwRVx0Ubuv5rWuhNnSEa=w480-h960-rw"
        cardData={episodes}
        showSearch={true}
        onEditDataItem={onEpisodeEdit}
        onDeleteDataItem={deleteEpisode}
        showTileView={true}
        inTileView={false}
        columnEntityName={'episode'}
        showPreferenceButton={true}
        onArchiveEpisodes={onArchiveEpisodes}
        loadEpisodes={loadEpisodes}
        showEpisodeArchiveCheckbox={true}
        archiveEpisode={archiveEpisode}
        setArchiveEpisode={setArchiveEpisode}
        enableSelection={true}
        showExport={true}
        showMultiVersioning={true}
        shortBy="EpisodeNumber"
        isLoading={isEpisodeLoading}
        source={{ entityName: ENTITYNAME.Season, _id: seasonEntity?._id }}
      />}

      <div className="main-layout">
        <EditPageHeader title={`${lang.series_dialog_header} -> ` + (seasonEntity.Title ? seasonEntity.Title : `${lang.new_button_dialog_header}`)} disableSave={disableSave} onSubmit={onSave} onCancel={onCancel} isLoading={isSaving} />

        <SeasonDetailForm
          loadEpisodes={loadEpisodes}
          tempSeasonEntity={tempSeasonEntity}
          dataItem={seasonEntity}
          selectedSeries={location?.state?.selectedSeries ?? selectedSeries}
          setSelectedSeries={setSelectedSeries}
          setDataItem={setSeasonEntity}
          setSeasonData={handleSetSeasonEntity}
          setSaveState={handleSetDisableSave}
          quickEdit={location?.state?.quickEdit ?? false}
          disableSelectSeries={location?.state?.disableSelectSeries ?? false}
          existingSeasons={location?.state?.existingSeason}
          setIsArchiveChanged={setIsArchiveChanged}
          isArchiveChanged={isArchiveChanged}
          createEpisodeDataItem={createEpisodeDataItem}
          setCreateEpisodeDataItem={setCreateEpisodeDataItem}
          onSave={onSave}
          isFromAddProgram={location?.state?.isFromAddProgram ?? false}
          isManualAssetId={isManualAssetId}
          setIsManualAssetId={setIsManualAssetId}
          entityName={props.entityname}
        />

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={tabNumber}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <TabList onChange={handleTabChange} variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
                  <Tab label={lang.meta_data_label} value="1" />
                  <Tab label={lang.publishing_label} value="2" />
                  <Tab label={lang.ott_assets_label} value="3" />
                  <Tab label={lang.transmission_label} value="4" />
                </TabList>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {seasonEntity?._id && (
                    <RoundButton
                      icon="arrows-rotate"
                      title={lang.sync_with_media_episodes_label}
                      onClick={() => setShowSyncSeasonWithEpisodeForm(true)}
                    />
                  )}
                  <BossAssistantIcon
                    style={{}}
                    mediaEpisodeEntity={mediaEpisodeEntity}
                    onDataLoad={onBossAIMetaDataLoad}
                    tooltip={"Generate full meta data with Boss AI"}
                    description={"BOSS AI Generating Meta Data"}
                    setMetaData={setMetaData}
                  />
                </Box>
              </Box>
            </Box>
            <TabPanel value="1">
              {isLoadedEdit && <SeasonMetaDataEditForm dataItem={seasonEntity} setMataData={setMataData} />}
            </TabPanel>
            <TabPanel value="2">
              <div className="row">
                <MediaEpisodePublishingEditForm
                  mediaCategory={mediaCategory.find((obj) => obj.SID == MEDIACATEGORIES.Season)}
                  mediaEpisodeEntity={mediaEpisodeEntity}
                  publishingSource={PUBLISHING_SOURCE.Season}
                  openPublishingDialog={openPublishingDialog}
                  setOpenPublishingDialog={setOpenPublishingDialog}
                  isNewMedia={!isEdit}
                />
              </div>
            </TabPanel>
            <TabPanel value="3">
              <div className="row mb-4" style={{ scrollbarWidth: "none", msOverflowStyle: 'none', overflow: 'auto', height: '63vh', boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "13px 0px 15px 5px" }}>
                <MediaEpisodeAssetEditForm source={'season'} sourceEntity={seasonEntity} entityname={ENTITYNAME.OttAsset} dataItem={assetDataItem} setDataEntity={setAssetEntity} setPotraitImageFiles={setPotraitImageFiles} setLandscapeImageFiles={setLandscapeImageFiles} selectedLanguage={company.Language} />
              </div>
            </TabPanel>
            <TabPanel value="4">
              <div className="row">
                <TransmissionBrowser isFromMedia={true} selectedNode={mediaEpisodeEntity} showToggle={true} query={["season_id", "=", mediaEpisodeEntity?._id]} mainStyle={{ height: 'calc(100vh - 300px)' }} gridStyle={{ height: 'calc(100vh - 520px)' }} entityName={ENTITYNAME.Season} />
              </div>
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </div >
    {showAddEpisode && <AddNewEpisodesForm seasonData={seasonEntity} episodes={episodes} setEpisodes={handleSetingEpisode} cancelEdit={onShowHideAddEpisode} />}
    {showSyncSeasonWithEpisodeForm && <SyncSeasonWithEpisodeForm seasonId={seasonEntity?._id} dataItem={seasonEntity} onClose={(isSuccess) => {
      setShowSyncSeasonWithEpisodeForm(false);
      if (isSuccess === true) { loadEpisodes(); }
    }} />}
  </>
  )
}

export default SeasonEditForm;
